module.exports = __webpack_public_path__ + "static/img/默认图片.803cde6d.png";